import { format } from 'date-fns';
import React, { useState } from 'react';
import { FaFolder, FaPaperclip } from 'react-icons/fa';
import { FaPenClip } from 'react-icons/fa6';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight, MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from 'react-icons/md';

const ArquivoPedidoTable = ({ refModal, pedidos, statusPedido, statusPagamento }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    const totalPages = Math.ceil(pedidos.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentItems = pedidos.sort((a, b) => new Date(a.data_pedido) - new Date(b.data_pedido)).slice(startIndex, endIndex);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <div>
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th>N° Pedido</th>
                        <th>Nome Cliente</th>
                        <th>Nome Vendedor</th>
                        <th>Data Do Pedido</th>
                        <th>Valor Total Pedidos (R$)</th>
                        <th>Saldo Devedor (R$)</th>
                        <th>Status Pedido</th>
                        <th>Status Pagamento</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    {currentItems.map((produto) => (
                        <tr key={produto.pedido_id} className='anexos_pedido'>
                            <td>{produto.pedido_id}</td>
                            <td>{produto.nomeCliente}</td>
                            <td>{produto.nomeVendedor}</td>
                            <td>{format(new Date(produto.data_pedido), "dd/MM/yyyy")}</td>
                            <td>R$ {produto.valor_total.toFixed(2).replace(".", ",")}</td>
                            <td>R$ {produto.saldo_devedor.toFixed(2).replace(".", ",")}</td>
                            <td>{statusPedido.find(x => x.status_pedido_id === produto.status_pedido_id)?.nome}</td>
                            <td>{statusPagamento.find(x => x.status_pagamento_id === produto.status_pagamento_id)?.nome}</td>
                            <td style={{ display: 'flex', gap: 10 }}>
                                <button className='btn btn-primary' onClick={e => refModal.current.verFiles(produto.pedido_id)}>
                                    <FaFolder />Arquivos
                                </button>
                                <button className='btn btn-primary' onClick={e => refModal.current.newFile(produto.pedido_id)}>
                                    <FaPaperclip /> Anexar Novo Arquivo
                                </button>
                            </td>
                        </tr>
                    ))}
                    {pedidos.length === 0 && (
                        <tr>
                            <td colSpan="8">Não foi encontrado nenhum pedido...</td>
                        </tr>
                    )}
                </tbody>
            </table>

            <div className="pagination">
                <button className='btn btn-primary' onClick={() => handlePageChange(1)} disabled={currentPage === 1}><MdKeyboardDoubleArrowLeft /></button>
                <button className='btn btn-primary' onClick={() => handlePageChange(currentPage - 10)} disabled={currentPage <= 10}><MdKeyboardDoubleArrowLeft /></button>
                <button className='btn btn-primary' onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}><MdKeyboardArrowLeft /></button>

                <span>Página {currentPage} de {totalPages}</span>

                <button className='btn btn-primary' onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}><MdKeyboardArrowRight /></button>
                <button className='btn btn-primary' onClick={() => handlePageChange(currentPage + 10)} disabled={currentPage + 10 > totalPages}><MdKeyboardDoubleArrowRight /></button>
                <button className='btn btn-primary' onClick={() => handlePageChange(totalPages)} disabled={currentPage + 10 > totalPages}><MdKeyboardDoubleArrowRight /></button>

                <select style={{ width: 50 }} className='form-control' value={itemsPerPage} onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}>
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                </select>
            </div>
        </div>
    );
};

export default ArquivoPedidoTable;